import React, { Component } from "react";
import config from "lib/fr-config";
import CommonSplitView from "presentational/common/CommonSplitView";
import ImageOnlyModalView from "presentational/common/modals/ImageOnlyModalView";
import OutfitImageView from "presentational/common/OutfitImageView";
import IconButtonView from "presentational/common/IconButtonView";
import CommonTextField from "presentational/common/CommonTextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import styles from "./DateSetUpPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const OUTFIT_IMAGE_WIDTH_PERCENT = 30;
const OUTFIT_VERTICAL_PADDING_PX = 10;
const IMAGE_RATIO = config.outfitImage.RATIO;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;

const CustomListItem = withStyles({
  root: { paddingLeft: 0, paddingRight: 0 }
})(ListItem);
const CustomCheckbox = withStyles({
  root: { marginLeft: -12 }
})(Checkbox);
const CustomListItemText = withStyles({
  primary: { fontSize: 14 }
})(ListItemText);

const cssXL = {
  buttonArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  },
  inputArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  }
};
const cssXS = {
  root: {
    marginTop: -mobileCss.paddingBetweenHeaderbarAndFirstContent
  },
  buttonArea: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  },
  imageFrame: {
    backgroundColor: colorCss.colorOfBackground,
    position: "sticky",
    top: 0,
    zIndex: 1200 /** 아웃핏 클릭후 나타나는 모달보다 약간 작은 값으로 설정함 */,

    /**
     * marginLeft, width: 상단에 떠있는 아웃핏 이미지의
     * 우측에 1px정도 짧게 계산되어 겹쳐있는 아이템 썸네일이 일부 노출된다
     * (안드로이드 모바일 한정)
     * 그래서 의도적으로 sidePadding 만큼의 좌우 마진 추가함.
     * */
    marginLeft: -mobileCss.sidePadding,
    width: `calc(100% + ${mobileCss.sidePadding * 2}px)`
  },
  imageWrapper: {
    width: `${OUTFIT_IMAGE_WIDTH_PERCENT}%`,
    padding: `${OUTFIT_VERTICAL_PADDING_PX}px 0`
  },
  inputArea: {
    marginTop: mobileCss.paddingBetweenHeaderbarAndFirstContentForOutfitUpload,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  }
};

class DateSetUpPanelView extends Component {
  static propTypes = {
    stickeredImageDataURL: PropTypes.string.isRequired,
    calendarDate: PropTypes.string.isRequired,
    calendarAgreement: PropTypes.bool.isRequired,
    onCalendarDateChange: PropTypes.func.isRequired,
    onCalendarAgreementChange: PropTypes.func.isRequired,
    onBackBtnClick: PropTypes.func.isRequired,
    onNextBtnClick: PropTypes.func.isRequired
  };

  state = {
    open: false
  };

  getWidthOfLeftSide = fixedHeightValue => {
    const { innerHeight } = window;
    const imageHeight = innerHeight - fixedHeightValue;
    return imageHeight * IMAGE_RATIO;
  };

  handleModalOpen = () => {
    this.setState({ open: true });
  };

  handleModalClose = () => {
    this.setState({ open: false });
  };

  handleCalendarDateChange = e => {
    const { onCalendarDateChange } = this.props;
    const calendarDate = e.target.value;
    onCalendarDateChange(calendarDate);
  };

  handleCheckboxChange = e => {
    const { onCalendarAgreementChange } = this.props;
    const { value, checked } = e.target;
    if (value === "calendarAgreement") {
      onCalendarAgreementChange(checked);
    }
  };

  mobileLayout() {
    const {
      stickeredImageDataURL,
      calendarDate,
      calendarAgreement,
      onBackBtnClick,
      onNextBtnClick
    } = this.props;
    const { open } = this.state;
    const css = cssXS;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)} style={css.root}>
        <div className={cx("main-area")}>
          <div style={css.imageFrame}>
            <div
              className={cx("image-wrapper")}
              style={css.imageWrapper}
              onClick={this.handleModalOpen}
            >
              <OutfitImageView imageSrc={stickeredImageDataURL} />
            </div>
          </div>
          <ImageOnlyModalView
            open={open}
            imageRatio={IMAGE_RATIO}
            imageSrc={stickeredImageDataURL}
            onClose={this.handleModalClose}
          />
          <div style={css.inputArea}>
            <CommonTextField
              label={<TXT name="wordPlaceholder_calendarDate" />}
              margin="none"
              type="date"
              shrinkLabel
              value={calendarDate}
              onChange={this.handleCalendarDateChange}
            />
            <List>
              <CustomListItem>
                <CustomCheckbox
                  checked={calendarAgreement}
                  onChange={this.handleCheckboxChange}
                  value={"calendarAgreement"}
                  disableRipple
                />
                <CustomListItemText
                  primary={<TXT name="msg_displayCalendarChkbox" />}
                />
              </CustomListItem>
            </List>
          </div>
        </div>
        <div className={cx("button-area")} style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"back"} onClick={onBackBtnClick} />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"next"} onClick={onNextBtnClick} />
          </div>
        </div>
      </div>
    );
  }

  desktopLayout() {
    const {
      stickeredImageDataURL,
      calendarDate,
      calendarAgreement,
      onBackBtnClick,
      onNextBtnClick
    } = this.props;
    const { open } = this.state;
    const css = cssXL;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)}>
        <CommonSplitView
          getWidthOfLeftSide={this.getWidthOfLeftSide}
          leftSideComponent={
            <div className={cx("float-area")}>
              <div
                className={cx("image-wrapper")}
                onClick={this.handleModalOpen}
              >
                <OutfitImageView imageSrc={stickeredImageDataURL} />
              </div>
              <ImageOnlyModalView
                open={open}
                imageRatio={IMAGE_RATIO}
                imageSrc={stickeredImageDataURL}
                onClose={this.handleModalClose}
              />
            </div>
          }
          rightSideComponent={
            <div>
              <div className={cx("button-area")} style={css.buttonArea}>
                <IconButtonView type={"back"} onClick={onBackBtnClick} />
                <IconButtonView
                  type={"next"}
                  disableRightMargin
                  onClick={onNextBtnClick}
                />
              </div>
              <div style={css.inputArea}>
                <CommonTextField
                  label={<TXT name="wordPlaceholder_calendarDate" />}
                  margin="none"
                  type="date"
                  shrinkLabel
                  value={calendarDate}
                  onChange={this.handleCalendarDateChange}
                />
                <List>
                  <CustomListItem>
                    <CustomCheckbox
                      checked={calendarAgreement}
                      onChange={this.handleCheckboxChange}
                      value={"calendarAgreement"}
                      disableRipple
                    />
                    <CustomListItemText
                      primary={<TXT name="msg_displayCalendarChkbox" />}
                    />
                  </CustomListItem>
                </List>
              </div>
            </div>
          }
        />
        <div className={cx("main-area")}></div>
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }
}

export default DateSetUpPanelView;
